import type { ComponentsTheme } from 'providers/ComponentsThemeProvider'
import styled from 'styled-components'
import type { Props } from './types'

type ContainerProps = {
  $isOpen: boolean
  $appearance?: Props['appearance']
  theme: ComponentsTheme
}

const getColor = ({ $appearance, $isOpen, theme }: ContainerProps) => {
  if ($appearance === 'primary') {
    return $isOpen
      ? 'var(--text-primary)'
      : theme.automated?.styles?.colorOnBackground || 'var(--text-primary)'
  }

  if ($appearance === 'secondary') {
    return 'var(--text-secondary)'
  }
}

export const TooltipContainer = styled.div<ContainerProps>`
  color: ${getColor};
  cursor: pointer;

  &:hover {
    color: var(--text-brand);
  }
`
